/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

function Mapa() {
  return (
    <section className="py-5" style={{ backgroundColor: 'var(--background)' }}>
      <div className="container px-5 my-5" id="container_ubicacion">
        <div className="row gx-5 align-items-center" id="section_ubicacion">
          {/* Section Header */}
          <div className="col-lg-4 mb-5 mb-lg-0">
            <div className="animate-fade-in-up">
              <span className="text-uppercase fw-bold text-primary-color" style={{ letterSpacing: '2px', fontSize: '0.875rem' }}>
                Encuéntranos
              </span>
              <h2 className="section-title mt-2">
                Ubicación
              </h2>
              
              <div className="d-flex align-items-start gap-3 mt-4">
                <div 
                  className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                  style={{ 
                    width: '45px', 
                    height: '45px', 
                    background: 'var(--primary-gradient)',
                    color: 'white'
                  }}
                >
                  <FontAwesomeIcon icon={faMapMarkerAlt} />
                </div>
                <div>
                  <h5 className="mb-1" style={{ fontFamily: 'var(--font-heading)' }}>
                    Buenos Aires 796
                  </h5>
                  <p className="mb-0" style={{ color: 'var(--text-secondary)' }}>
                    Valparaíso, Chile
                  </p>
                </div>
              </div>
              
              <a 
                href="https://maps.app.goo.gl/E5K9wYX5FVhgWDKV6"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary mt-4"
              >
                Abrir en Google Maps
              </a>
            </div>
          </div>
          
          {/* Map */}
          <div className="col-lg-8">
            <div 
              className="rounded-4 overflow-hidden shadow-lg animate-fade-in-up animate-delay-200"
              style={{ border: '4px solid white' }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3344.271381171158!2d-71.62108298452917!3d-33.049321480890676!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9689e0d1bda4c1f9%3A0x393d34a7532b72c5!2sCl%C3%ADnica%20Veterinaria%20Pichos!5e0!3m2!1ses-419!2scl!4v1670349697922!5m2!1ses-419!2scl"
                width="100%"
                height="400"
                style={{ border: 0, display: 'block' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Mapa;
